class HaloCarousel extends HTMLElement {
  constructor() {
    super();
    this.interval = parseInt(this.dataset.interval || '6500', 10);
    this.slides = [];
    this.dots = [];
    this.currentIndex = 0;
    this.timerId = null;
    this.paused = false;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.halo-carousel__slide'));
    this.dots = Array.from(this.querySelectorAll('.halo-carousel__dot'));
    this.prevBtn = this.querySelector('.halo-carousel__arrow--prev');
    this.nextBtn = this.querySelector('.halo-carousel__arrow--next');

    if (this.slides.length <= 1) return;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.go(-1);
        this.restartTimer();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.go(1);
        this.restartTimer();
      });
    }

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restartTimer();
      });
    });

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.resume());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', (e) => {
      if (!this.contains(e.relatedTarget)) this.resume();
    });

    if (typeof IntersectionObserver === 'function') {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.paused) {
            this.startTimer();
          } else {
            this.stopTimer();
          }
        });
      }, { threshold: 0.25 });
      this.observer.observe(this);
    } else {
      this.startTimer();
    }
  }

  disconnectedCallback() {
    this.stopTimer();
    if (this.observer) this.observer.disconnect();
  }

  go(direction) {
    const total = this.slides.length;
    const next = (this.currentIndex + direction + total) % total;
    this.goTo(next);
  }

  goTo(index) {
    if (index === this.currentIndex) return;
    const prev = this.slides[this.currentIndex];
    const next = this.slides[index];
    const prevDot = this.dots[this.currentIndex];
    const nextDot = this.dots[index];

    if (prev) prev.classList.remove('is-active');
    if (next) next.classList.add('is-active');
    if (prevDot) {
      prevDot.classList.remove('is-active');
      prevDot.setAttribute('aria-selected', 'false');
    }
    if (nextDot) {
      nextDot.classList.add('is-active');
      nextDot.setAttribute('aria-selected', 'true');
    }
    this.currentIndex = index;
  }

  startTimer() {
    this.stopTimer();
    if (this.paused) return;
    if (this.slides.length <= 1) return;
    this.timerId = window.setInterval(() => this.go(1), this.interval);
  }

  stopTimer() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  restartTimer() {
    this.stopTimer();
    if (!this.paused) this.startTimer();
  }

  pause() {
    this.paused = true;
    this.stopTimer();
  }

  resume() {
    this.paused = false;
    this.startTimer();
  }
}

if (!customElements.get('halo-carousel')) {
  customElements.define('halo-carousel', HaloCarousel);
}
